<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     映射规则编辑器
  +---------------------------------------------------------------------------------------
-->
<template>
  <el-dialog
    class="mapping-editer"
    width="600px"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    :modal-append-to-body="true"
    append-to-body>
    <div slot="title">
      <span class="font-lg middle">
        <span v-if="sen.sen_name">{{ sen.sen_name }} | </span>
        <span>映射规则</span>
        <span v-popover:popover class="ml"><i class="el-icon-info text-light"></i></span>
        <el-popover
          ref="popover"
          placement="bottom"
          trigger="hover">
          <div v-if="sen.sen_type == 1">
            <p>为数值型参数添加线性映射规则</p>
            <p><i class="el-icon-s-opportunity text-success" /> 例1：压力：<br>
            内存值为 720，对应实际值 7.20bar，即缩小100倍<br>
            则规则为：<b>[0, 100] => [0, 1]</b></p>
            <p><i class="el-icon-s-opportunity text-success" /> 例2：温度：<br>
            内存范围 0~1900，对应实际值 -40~150℃，即偏移后缩小10倍<br>
            则规则为：<b>[0, 1900] => [-40, 150]</b></p>
          </div>
  
          <div v-if="sen.sen_type == 2">
            <p>为档位型参数添加档位映射规则</p>
            <p><i class="el-icon-s-opportunity text-success" /> 例1：运行状态：<br>
            1代表制冷，2代表制热，<br>
            则规则为：<b>1 => 制冷，2 => 制热</b></p>
            <p><i class="el-icon-s-opportunity text-success" /> 例2，控制模式：<br>
            0代表禁用，1代表温度控制，2代表压力控制<br />
            则规则为：<b>0 => 禁用，1 => 温度控制，2 => 压力控制</b></p>
          </div>
        </el-popover>
      </span>
    </div>

    <div v-loading="loading" class="pl pr">
      <el-tabs v-model="currentTab">
        <el-tab-pane label="从映射库选择" name="kk">
          <el-scrollbar class="v-only" :native="false">
            <el-table
              ref="mappingsTable"
              :data="mappings"
              :show-header="false"
              :row-style="{ 'height': '52px' }"
              @row-click="selectMapping">
              <el-table-column type="index" width="60" />
              <el-table-column prop="title" label="描述" />
              <el-table-column width="60">
                <template slot-scope="scope">
                  <span v-if="scope.row.mappingid === selectedMappingid" class="text-success font-2x middle">
                    <i class="el-icon-check"></i>
                  </span>
                </template>
              </el-table-column>
              <el-table-column width="60">
                <template slot-scope="scope">
                  <i v-if="scope.row.mappingid !== selectedMappingid" class="el-icon-delete hover-show" role="button" @click.stop="deleteMapping(scope.row)"></i>
                </template>
              </el-table-column>
            </el-table>
          </el-scrollbar>
        </el-tab-pane>

        <el-tab-pane label="手动输入" name="input">
          <el-form v-if="sen.sen_type == 1" ref="linearMappingForm" label-width="120px" label-position="left" :model="formData" :rules="linearFormRules" style="height: 300px;">
            <el-form-item label="最小值" prop="field1">
              <el-input v-model="formData.field1" clearable />
            </el-form-item>
            <el-form-item label="最大值" prop="field2">
              <el-input v-model="formData.field2" clearable />
            </el-form-item>
            <el-form-item label="转换后最小值" prop="field3">
              <el-input v-model="formData.field3" clearable />
            </el-form-item>
            <el-form-item label="转换后最大值" prop="field4">
              <el-input v-model="formData.field4" clearable />
            </el-form-item>
            <el-form-item>
              <el-checkbox v-model="formData.save" :false-label="0" :true-label="1">保存至映射库</el-checkbox>
            </el-form-item>
          </el-form>

          <el-scrollbar v-if="sen.sen_type == 2" class="v-only" :native="false">
            <el-table
              :data="formData.gears"
              :show-header="false">
              <el-table-column>
                <template slot-scope="scope">
                  <el-form :ref="'gearMappingForm' + scope.$index" :inline="true" :model="scope.row" :rules="gearFormRules">
                    <el-form-item prop="key">
                      <el-input v-model="scope.row.key" placeholder="内存值" style="width: 160px;" />
                    </el-form-item>
                    <el-form-item>
                      <span style="display: inline-block; width: 40px; text-align: center;"><i class="el-icon-d-arrow-right" /></span>
                    </el-form-item>
                    <el-form-item prop="value">
                      <el-input v-model="scope.row.value" placeholder="转换后值" style="width: 160px;" />
                    </el-form-item>
                  </el-form>
                </template>
              </el-table-column>
              <el-table-column width="50" align="center">
                <template slot-scope="scope">
                  <span role="button" @click="removeGear(scope.row)">
                    <i class="el-icon-circle-close font-lg text-muted"></i>
                  </span>
                </template>
              </el-table-column>
            </el-table>
            <div class="flex align-items-center">
              <div class="bd pl-sm"><el-button type="text" icon="el-icon-plus" @click="addGear">增加一行</el-button></div>
              <div class="ft pr"><el-checkbox v-model="formData.save" :false-label="0" :true-label="1">保存至映射库</el-checkbox></div>
            </div>
          </el-scrollbar>
        </el-tab-pane>
      </el-tabs>
    </div>

    <div slot="footer" class="text-center">
      <el-button class="extend" plain @click="dialogShow = false">取消</el-button>
      <el-button class="extend" type="primary" :loading="posting" @click="submit">提交</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { getSenApi } from '@/api/senApi'
import { singleMappingApi, deleteMappingApi } from '@/api/mappingApi'
export default {
  name: 'MappingEditer',

  props: {
    show: {
      type: [Boolean, Number],
      default: false
    },

    senid: {
      type: Number,
      default: undefined
    }
  },

  data() {
    var validatePass = (rule, value, callback) => {
      if (value === null || value === undefined || value === '') {
        callback(new Error('不能为空'));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      sen: {},

      currentTab: 'kk',
      selectedMappingid: undefined,
      formData: {
        field1: '',
        field2: '',
        field3: '',
        field4: '',
        gears: [],
        save: 0
      },
      linearFormRules: {},
      gearFormRules: {
        key: [
          { required: true, message: '不能为空', trigger: 'blur' }
        ],
        value: [
          { required: true, validator: validatePass, trigger: 'blur' }
        ]
      },
      posting: false,
    }
  },

  computed: {
    dialogShow: {
      get() {
        return !!this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    },

    mappings() {
      return this.$store.state.devStore.mappingsArr.filter(v => v.mapping_type == this.sen.sen_type)
    },
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      this.loading = true
      getSenApi({ senid: this.senid }).then(res => {
        this.loading = false
        if (!res.errno) {
          this.sen = Object.assign({}, res.data.sen)
          // 映射值初始化
          if (this.sen.sen_type == 1) {
            this.formData.field1 = this.sen.field1
            this.formData.field2 = this.sen.field2
            this.formData.field3 = this.sen.field3
            this.formData.field4 = this.sen.field4
          }
          if (this.sen.sen_type == 2) {
            this.formData.gears = this.gearsObj2Arr(this.sen.field1)
            if (!this.formData.gears.length) this.addGear()
          }
          // 编辑时切换至手动输入
          if (this.sen.mapping_title) {
            this.currentTab = 'input'
          }
        } else {
          this.$message.error(res.message)
        }
      })
    },

    gearsObj2Arr(obj) {
      const gears = []
      for (var [key, value] of Object.entries(obj)) {
        gears.push({ key, value })
      }
      return gears
    },
    gearsArr2Obj(arr) {
      const gears = {}
      arr.forEach((item) => {
        gears[item.key] = item.value
      })
      return gears
    },
    addGear() {
      this.formData.gears.push({
        key: '',
        value: ''
      })
    },
    removeGear(row) {
      this.formData.gears.splice(this.formData.gears.indexOf(row), 1)
    },

    selectMapping(row) {
      if (this.sen.sen_type == 1) {
        this.formData.field1 = row.field1
        this.formData.field2 = row.field2
        this.formData.field3 = row.field3
        this.formData.field4 = row.field4
      }
      if (this.sen.sen_type == 2) {
        this.formData.gears = this.gearsObj2Arr(row.field1)
      }
      this.selectedMappingid = row.mappingid
    },

    submit() {
      let validCheck = true
      let pl

      if (this.sen.sen_type == 1) {
        this.$refs['linearMappingForm'].validate((valid) => {
          validCheck = valid 
        })
        pl = {
          senid: this.senid,
          field1: this.formData.field1,
          field2: this.formData.field2,
          field3: this.formData.field3,
          field4: this.formData.field4,
          save: this.formData.save,
        }
      } else if (this.sen.sen_type == 2) {
        const refArr = Object.keys(this.$refs)
        for (var i = 0; i < refArr.length; i++) {
          if (this.$refs[refArr[i]] && refArr[i].indexOf('gearMappingForm') === 0) {
            this.$refs[refArr[i]].validate((valid) => {
              if (!valid) {
                validCheck = false
              }
            })
          }
        }
        pl = {
          senid: this.senid,
          field1: this.gearsArr2Obj(this.formData.gears),
          save: this.formData.save
        }
      } else {
        validCheck = false
      }

      if (validCheck) {
        this.posting = true
        singleMappingApi(pl).then(res => {
          this.posting = false
          if (!res.errno) {
            this.dialogShow = false
            this.$message.success(res.message)
            this.$store.dispatch('fetchDataAction')
            this.$emit('submit')
          } else {
            this.$message.error(res.message)
          }
        })
      }
    },


    deleteMapping(mapping) {
      const msg = `此操作将删除映射规则 <span class="text-danger">${mapping.title}</span>，删除对已经映射的参数没有影响，是否继续？`
      this.$confirm(msg, {
        type: 'error',
        dangerouslyUseHTMLString: true
      }).then(() => {
        const mappingids = [mapping.mappingid]
        deleteMappingApi({mappingids}).then(res => {
          if (!res.errno) {
            this.$message.success(res.message)
            this.$store.dispatch('getallMappingAction')
          } else {
            this.$message.error(res.message)
          }
        })
      }).catch((err) => {
        console.log(err)
      })
    },
  }
}
</script>

<style lang="scss" scoped>
.mapping-editer {
  .el-scrollbar {
    height: 300px;
  }
  .el-form--inline .el-form-item {
    margin-bottom: 0px;
  }
}
</style>
